module.exports = __webpack_public_path__ + "img/ic_outline-cancel.efbcda78.svg";